import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import jwtAuthAxios from 'services/jwtAuth';

export const getPayment = createAsyncThunk("payment/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.get(`v1/pembayaran/get-user`);
    const response = await jwtAuthAxios.get(`v1/payment/user`);
    return response.data;
});
export const getPaymentById = createAsyncThunk("payment/getPaymentById", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.get(`v1/pembayaran/get-user`);
    const response = await jwtAuthAxios.get(`v1/payment/${id}`);
    return response.data;
});
export const getPaymentDetail = createAsyncThunk("payment/getDetailAll", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/payment-detail/trx/${val}`);
    return response.data;
});

export const getXenditPayCheck = createAsyncThunk("payment/getXenditPayCheck", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/xendit/pay/check-invoice/${val}`);
    return response.data;
});

export const getXenditPayExecute = createAsyncThunk("payment/getXenditPayExecute", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/xendit/pay/create-invoice/${val}`);
    return response.data;
});


export const findByNameOrEmail = createAsyncThunk("payment/findByNameOrEmail", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/find/nameoremail`,val);
    return response.data;
});

export const getTotalTagihanMahasiswa = createAsyncThunk("payment/getTotalTagihanMahasiswa", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/payment/tagihan/pembayaran`,val);
    return response.data;
});

const initialState = {
    loading : false,
    dataList : [],
    detailList : [],
    detailSearch : [],
    dataPayment : {},
    dataTagihan : {},
    commonResponsePayment : {}
}

const paymentSlice = createSlice({
    name:"paymentSlice",
    initialState: initialState,
    extraReducers: {
        [getPayment.pending] : (state, action) => {
            state.loading = true;
        },
        [getPayment.fulfilled] : (state, action) => {
            state.dataList = action.payload;
            state.loading = false;
        },
        [getPayment.pending] : (state, action) => {
            state.loading = true;
        },
        [getPaymentById.pending] : (state, action) => {
            state.loading = true;
        },
        [getPaymentById.fulfilled] : (state, action) => {
            state.dataPayment = action.payload;
            state.loading = false;
        },
        [getPaymentById.pending] : (state, action) => {
            state.loading = true;
        },
        [getPaymentDetail.pending] : (state, action) => {
            state.loading = true;
        },
        [getPaymentDetail.fulfilled] : (state, action) => {
            state.detailList = action.payload;
            state.loading = false;
        },
        [getPaymentDetail.pending] : (state, action) => {
            state.loading = true;
        },

        [getXenditPayCheck.fulfilled] : (state, action) => {
            state.commonResponsePayment = action.payload;
            state.loading = false;
        },
        [getXenditPayCheck.pending] : (state, action) => {
            state.loading = true;
        },
        [getXenditPayCheck.rejected] : (state, action) => {
            state.loading = false;
        },

        [getXenditPayExecute.fulfilled] : (state, action) => {
            state.commonResponsePayment = action.payload;
            state.loading = false;
        },
        [getXenditPayExecute.pending] : (state, action) => {
            state.loading = true;
        },
        [getXenditPayExecute.rejected] : (state, action) => {
            state.loading = false;
        },

        [findByNameOrEmail.fulfilled] : (state, action) => {
            state.detailSearch = action.payload;
            state.loading = false;
        },
        [findByNameOrEmail.pending] : (state, action) => {
            state.loading = true;
        },
        [findByNameOrEmail.rejected] : (state, action) => {
            state.loading = false;
        },

        [getTotalTagihanMahasiswa.fulfilled] : (state, action) => {
            state.dataTagihan = action.payload;
            state.loading = false;
        },
        [getTotalTagihanMahasiswa.pending] : (state, action) => {
            state.loading = true;
        },
        [getTotalTagihanMahasiswa.rejected] : (state, action) => {
            state.loading = false;
        },
        
    }
})

export const paymentSelector = (state) => state.payment;
export default paymentSlice.reducer;